import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Toast from './Toast';

class ModalToaster extends Component {
  renderToast = (toast) => {
    const {
      closeToasterFn, dismissTimeoutMS, transitionTimeoutMS, styles
    } = this.props;
    return (
      <CSSTransition key={toast.get('key')} classNames="generic-modal-toaster__transition" timeout={transitionTimeoutMS}>
        <Toast
          toastKey={toast.get('key')}
          type={toast.get('type')}
          message={toast.get('message')}
          closeToasterFn={closeToasterFn}
          dismissTimeoutMS={dismissTimeoutMS}
          style={styles.toast}
        />
      </CSSTransition>
    );
  }

  render() {
    const {
      toasts, queueSize, style, styles
    } = this.props;
    return (
      <div className="generic-modal-toaster__wrapper" style={style || styles.base}>
        <div className="generic-modal-toaster__container">
          <TransitionGroup>
            {
              toasts.slice(0, queueSize).map(this.renderToast).reduce((acc, curr) => {
                acc.push(curr);
                return acc;
              }, [])
            }
          </TransitionGroup>
        </div>
      </div>
    );
  }
}

ModalToaster.propTypes = {
  // required
  toasts: PropTypes.any.isRequired,
  // optional
  closeToasterFn: PropTypes.func,
  transitionTimeoutMS: PropTypes.number,
  dismissTimeoutMS: PropTypes.number,
  queueSize: PropTypes.number,
  style: PropTypes.objectOf(PropTypes.any),
  styles: PropTypes.objectOf(PropTypes.any)
};

ModalToaster.defaultProps = {
  transitionTimeoutMS: 200,
  queueSize: 3,
  style: {},
  styles: {},
  closeToasterFn: null,
  dismissTimeoutMS: null
};

export default ModalToaster;
